// src/components/LazyApexChart.js
import loadable from "@loadable/component";

const ApexCharts = loadable(() => import("react-apexcharts"), {
  fallback: "Loading chart...",
});

export default ApexCharts;
